// 举报用户 类型;
export enum ReportType {
  AVATAR_VIOLATION,
  NICKNAME_VIOLATION,
  PERSONAL_INFO_VIOLATION,
  REPORT_CONTENT_OTHER,
  PORN_AND_VULGAR,
  FALSE_INFO,
  PERSONAL_ATTACK,
  GORY_AND_VIOLENT,
  ILLEGAL_EXTERNAL_LINK,
  REPORT_REASON_OTHER,
}
// 个人中心 组件名称;
export enum UserCenterComponent {
  UserHome = "UserHome",
  UserPublish = "UserPublish",
  UserSetting = "UserSetting",
  UserCollect = "UserCollect",
  UserBrowsingHistory = "UserBrowsingHistory",
  UserDownloadHistory = "UserDownloadHistory",
}

/** 个人中心 所有 子组件名称 */
export enum UserCenterSubComp {
  Followings = "Followings",
  Followers = "Followers",
  UserCollectDetail = "UserCollectDetail",
  UserCollectEdit = "UserCollectEdit", // UserCollectEdit弃用
}
// 个人中心 UserPublish组件的子组件
export enum UserPublishSubComp {
  PublishedModels = "publishedModels",
  PPublishedPrintConfig = "publishedPrintConfig",
  VVerifyingModels = "verifyingModels",
  FailedModels = "failedModels",
  DraftModels = "draftModels",
}

/** 个人中心组件 对应的 子组件 */
export interface UserCenterCompToSubComp {
  [UserCenterComponent.UserHome]:
    | UserCenterSubComp.Followings
    | UserCenterSubComp.Followers;
  [UserCenterComponent.UserCollect]:
    | UserCenterSubComp.UserCollectDetail
    | UserCenterSubComp.UserCollectEdit;
}
